import { render, staticRenderFns } from "./Notifications.vue?vue&type=template&id=a0064bd2&scoped=true&"
import script from "./Notifications.vue?vue&type=script&lang=js&"
export * from "./Notifications.vue?vue&type=script&lang=js&"
import style0 from "./_Notifications.scss?vue&type=style&index=0&id=a0064bd2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0064bd2",
  null
  
)

export default component.exports